import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import MainLayout from './Components/Layout/MainLayout';
import Home from './Components/pages/Home';
import Leads from './Components/pages/Leads';
import Login from './Components/pages/Login';
import ProtectedRoute from './Components/RouteProtector/Protectedrouter';
import ProjectCreate from './Components/pages/Projects';
import Service from './Components/pages/Service';
function App() {

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/dashboard",
      element: (<ProtectedRoute><MainLayout /></ProtectedRoute>),
      children: [
        { path: "", element: <Home /> },
        { path: "leads", element: <Leads/> },
        { path: "projects", element: <ProjectCreate/> },
        { path: "services", element: <Service/> }
      ]
    }
  ])
  return (
    <RouterProvider router={router} />
  );
}

export default App;

